import React, { useState } from "react";

export const UploadContext = React.createContext({
    uploadProgress: {
        uploading: false,
        visible: false,
        percentage: 0,
        uploaded: 0,
        total: 0,
        status: "uploading", // uploading | success | error
        message: "",
    },
    updateUploadProgress: (data: any) => { },
    resetUploadProgress: () => { },
});

const UploadProvider = (props: any) => {
    const [uploadProgress, setUploadProgress] = useState({
        uploading: false,
        visible: false,
        percentage: 0,
        uploaded: 0,
        total: 0,
        status: "uploading", // uploading | success | error
        message: "",
    });

    const updateUploadProgress = (data: any) => {
        setUploadProgress((prev) => ({
            ...prev,
            ...data,
        }));
    };

    const resetUploadProgress = () => {
        setUploadProgress({
            uploading: false,
            visible: false,
            percentage: 0,
            uploaded: 0,
            total: 0,
            status: "uploading", // uploading | success | error
            message: "",
        });
    };

    // useEffect(() => {
    //     const handleBeforeUnload = (event: BeforeUnloadEvent) => {
    //         if (!uploadProgress.uploading) return;
    //         event.preventDefault();
    //         event.returnValue = "Images are uploading. Are you sure you want to leave?";
    //     };

    //     window.addEventListener("beforeunload", handleBeforeUnload);

    //     return () => {
    //         window.removeEventListener(
    //             "beforeunload",
    //             handleBeforeUnload
    //         );
    //     };
    // }, [uploadProgress.uploading]);

    return (
        <UploadContext.Provider
            value={{
                uploadProgress,
                updateUploadProgress,
                resetUploadProgress,
            }}
        >
            {props.children}
        </UploadContext.Provider>
    );
};

export default UploadProvider;